import { Injectable } from '@angular/core';
import { ListLayoutMultipleComponent, ListLayout } from 'gung-list';
import { ConceptTreeListConfigService, ConceptTreeTableViewComponent, ProductConcept } from 'gung-standard';
import { forkJoin, Observable, first, map, mergeMap, of } from 'rxjs';
import { OttoOlsenConceptTreeListViewComponent } from '../components/otto-olsen-concept-tree-list-view/otto-olsen-concept-tree-list-view.component';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenConceptTreeListConfigService extends ConceptTreeListConfigService {
  getLayouts(): ListLayout<ProductConcept>[] {
    if (this.pimOptions && this.pimOptions.showAsList) {
      return [
        {
          getIconClass: () => '',
          getListItemComponent: () => ConceptTreeTableViewComponent,
          getListLayoutComponent: () => ListLayoutMultipleComponent,
          getName: () => 'ProductGrid'
        }
      ];
    }
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => OttoOlsenConceptTreeListViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      }
    ];
  }

  getBatchSizes(): number[] {
    return [500];
  }

  getItems(): Observable<ProductConcept[]> {
    return super.getItems().pipe(
      mergeMap(assorments => forkJoin([of(assorments), this.authService.getRoles().pipe(first())])),
      map(([assortments, roles]) => {
        if (!roles.includes('SALES') && !roles.includes('ADMIN')) {
          // Hide concept not active in B2B for users
          return assortments.filter(a => {
            return a.extra.pim?.activeInB2B;
          });
        }
        return assortments;
      })
    );
  }

  getSearchTerms(item: ProductConcept) {
    return [...super.getSearchTerms(item), item.extra.pim.keywords];
  }
}
